import { parseDateSafely } from "@nova/format"
import { SidePanelStatus } from "@nova/component-side-panel-tab-container"
import {
    ImageProcessingState,
    JobStatusType,
    layerVisibilityLocalStorageKey,
} from "@nova/constants"

export const dateInMs = (date?: number | string) => {
    if (typeof date === "number") return date
    if (!date) return 0
    return parseDateSafely(date).getTime()
}

export const getJobStatus = (
    summary: { stateCount?: Record<number, number>; uploadCount?: number },
    status?: JobStatusType
) => {
    const processing = status === JobStatusType.STARTED || status === JobStatusType.QUEUED
    const failed = status === JobStatusType.FAILED
    const uploadInProgress =
        !!summary.stateCount &&
        (summary.stateCount[ImageProcessingState.PendingUpload] > 0 ||
            summary.stateCount[ImageProcessingState.Uploading] > 0 ||
            summary.stateCount[ImageProcessingState.UploadDone] > 0) &&
        summary.stateCount[ImageProcessingState.IngestDone] !== summary.uploadCount
    const uploadAmount = summary.stateCount?.[ImageProcessingState.IngestDone]
    const uploadTotal = !!summary.uploadCount && summary.uploadCount
    const readyToProcess =
        !!uploadAmount &&
        uploadAmount === uploadTotal &&
        (status ? status < JobStatusType.COMPLETED : true)

    if (uploadInProgress && (summary.stateCount?.[ImageProcessingState.IngestDone] || 0) > 0)
        return SidePanelStatus.uploading
    if (uploadInProgress) return SidePanelStatus.queued
    if (processing) return SidePanelStatus.loading
    if (failed) return SidePanelStatus.failed
    if (readyToProcess) return SidePanelStatus.ready
    if (status ? status < JobStatusType.COMPLETED : true) return SidePanelStatus.upload
    return undefined
}

export const modifyHiddenLayerList = (id: string, visible?: boolean) => {
    if (visible === undefined) return

    const hiddenLayersJSON = localStorage.getItem(layerVisibilityLocalStorageKey)
    let hiddenLayersSet: Set<string> = new Set()

    if (hiddenLayersJSON) {
        const hiddenLayersArray: string[] = JSON.parse(hiddenLayersJSON)
        hiddenLayersSet = new Set(hiddenLayersArray)
    }

    if (visible === false) {
        hiddenLayersSet.add(id)
    } else if (visible === true) {
        hiddenLayersSet.delete(id)
    }

    localStorage.setItem(layerVisibilityLocalStorageKey, JSON.stringify([...hiddenLayersSet]))
}

export const addLayerVisibilityToEntities = <T extends { id: string }>(
    items: T[]
): Array<T & { visible: boolean }> => {
    const hiddenLayersJSON = localStorage.getItem(layerVisibilityLocalStorageKey)

    const hiddenLayersSet: Set<string> = hiddenLayersJSON
        ? new Set(JSON.parse(hiddenLayersJSON))
        : new Set()

    const visibilityItems = items.map((item) => {
        const isHidden = hiddenLayersSet.has(item.id)
        return { ...item, visible: !isHidden }
    })
    return visibilityItems
}
